<div class="article-dialog">
    <button mat-icon-button class="close-button" mat-dialog-close [attr.aria-label]="'Close article dialog' | translate: {Default: 'Close article dialog'}">
        <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
    </button>

    <mat-dialog-content role="document" aria-labelledby="article-dialog-title" [attr.aria-busy]="loading">
        <div *ngIf="loading" class="loading-state" aria-hidden="true">
            <ngx-skeleton-loader count="1" [theme]="{ 'height.px': 220, 'border-radius': '14px' }"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" [theme]="{ 'height.px': 28, 'width': '70%' }"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="4" [theme]="{ 'height.px': 16 }"></ngx-skeleton-loader>
        </div>
        <p class="sr-only" *ngIf="loading" aria-live="polite">
            {{ 'Loading article content' | translate: {Default: 'Loading article content'} }}
        </p>

        <ng-container *ngIf="!loading">
            <ng-container *ngIf="articleImage$ | withLoading | async as articleImage">
                <div class="article-media">
                    <img *ngIf="articleImage.value" [src]="articleImage.value" [alt]="article?.title || ('Article image' | translate: {Default: 'Article image'})">
                    <div *ngIf="articleImage.error" class="media-placeholder" role="img" [attr.aria-label]="'Error loading image' | translate: {Default: 'Error loading image'}">
                        <mat-icon class="material-icons-outlined" aria-hidden="true">broken_image</mat-icon>
                    </div>
                    <ngx-skeleton-loader *ngIf="articleImage.loading" count="1" aria-hidden="true"
                        [theme]="{ 'height.px': 220, 'margin': '0', 'border-radius': '14px' }"></ngx-skeleton-loader>
                </div>
            </ng-container>

            <header class="publish-details">
                <span class="publish-date">
                    {{ 'Published on' | translate: {Default: "Published on"} }} {{ articleVerbose?.lastEditedOn | date:'mediumDate' }}
                </span>
                <h2 id="article-dialog-title" tabindex="-1" cdkFocusInitial>{{ article?.title || ('Article details' | translate: {Default: 'Article details'}) }}</h2>
            </header>

            <div class="article-content" role="article" aria-labelledby="article-dialog-title" [innerHTML]="getSafeContent()"></div>
        </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-flat-button setColor="primaryColour" color="primary" class="done-button" mat-dialog-close>
            {{ 'Close' | translate: {Default: "Close"} }}
        </button>
    </mat-dialog-actions>
</div>
